/**
 * Idioma inicial de la app, y unico lugar donde se decide.
 *
 * Antes estaba en dos sitios y no coincidian: `app.component` ponia `'en'` si no habia
 * nada guardado, y el constructor de `login.page` forzaba `'spanish'` en **cada** visita
 * a la pantalla. Cual ganaba dependia del orden de construccion, y de paso el selector de
 * idioma de la propia pantalla de login no servia para nada: lo que eligieras se pisaba
 * al volver a entrar.
 *
 * El valor es `'spanish'` porque es lo que el comercio veia de hecho —login siempre
 * ganaba— y es el idioma del ecosistema. El nombre del diccionario es `spanish`, no `es`,
 * porque asi se llama el archivo: `src/assets/i18n/spanish.json`.
 */
export const DEFAULT_LANGUAGE = 'spanish';

/** Idiomas con diccionario en `src/assets/i18n/`. */
export const AVAILABLE_LANGUAGES = ['en', 'spanish'] as const;

/**
 * El codigo de idioma con el que se guardan las etiquetas en Firestore.
 *
 * ⚠️ **El ecosistema tiene tres esquemas de codigo de idioma distintos** y hay que
 * traducir entre ellos:
 *
 * | Donde | Codigos |
 * | --- | --- |
 * | esta app y `mitter-driver-app` | `spanish`, `en` |
 * | `mitter-panel` | `es-SP`, `en-US` |
 * | los documentos de Firestore (`rejectOrder.labels`) | `es`, `en` |
 *
 * Se eligio ISO de dos letras para los documentos porque es el unico de los tres que no
 * es propio de una app. Cada consumidor normaliza el suyo aca.
 */
export function codigoDeEtiqueta(idioma: string | null = localStorage.getItem('language')): string {
  return (idioma ?? DEFAULT_LANGUAGE).toLowerCase().startsWith('en') ? 'en' : 'es';
}
